// Generated by tools/actors/build_shenmue_controller_family_data.mjs.
export default {
  "format": "shenmue-controller-families-runtime-v1",
  "source": {
    "program": "1ST_READ.BIN",
    "executableTableAddress": "0x0c293ea4",
    "extractionScript": "tools/ghidra/ExportControllerFamilies.java"
  },
  "familyCount": 21,
  "families": [
    {
      "index": 0,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293ea4",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.1503999,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.25126198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.109730996,
            0,
            0.055834997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.049935997,
            0,
            0.035837
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16383
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.39272898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.44460797,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            -0.000001,
            -0.08824,
            -0.115664996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.109731995,
            0,
            -0.055836998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.049937,
            0,
            -0.035834998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16329
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.39272898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -102
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.44462398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            -0.08824,
            -0.115664996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.38085198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0,
            0.000001,
            0.000001
          ],
          "defaultRotationRaw": [
            -32768,
            -16384,
            0
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.209385,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.12563099,
            0,
            -0.055834
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.016950998,
            0,
            -0.16859
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 28,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.24252999,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.25065798,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.12563199,
            0,
            0.055837996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 32,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.016944999,
            0,
            0.16856599
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16451
          ]
        },
        {
          "index": 34,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.242525,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            133
          ]
        },
        {
          "index": 35,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.25066498,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 1,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293eb0",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.3195349,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.220002,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.061229996,
            0,
            0.083409995
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.031229999,
            0,
            0.1012
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16431
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.480113,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -91
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.48040798,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            -0.00001,
            -0.093936995,
            -0.086895995
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.061229996,
            0,
            -0.083409995
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.031229999,
            0,
            -0.1012
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16431
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.48011097,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -95
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.480411,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            -0.09437399,
            -0.086895995
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.682291,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0,
            0.000001,
            0.000001
          ],
          "defaultRotationRaw": [
            8191,
            -16384,
            24575
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.209385,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.26507,
            -0.01,
            -0.11604
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.062709995,
            0,
            -0.21395999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16444
          ]
        },
        {
          "index": 28,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.30000398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            119
          ]
        },
        {
          "index": 29,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.310002,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.26507,
            -0.01,
            0.11604
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 32,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.062709995,
            0,
            0.21395999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16444
          ]
        },
        {
          "index": 34,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.300005,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            119
          ]
        },
        {
          "index": 35,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.30999997,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 2,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293ebc",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.120971,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -1
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.22,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.078475,
            -0.0000029999999,
            0.05585
          ],
          "defaultRotationRaw": [
            0,
            -1,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.048479,
            0.000005,
            0.034144998
          ],
          "defaultRotationRaw": [
            1,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16329
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.39,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -102
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.44,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.078463994,
            0.000004,
            -0.055822
          ],
          "defaultRotationRaw": [
            0,
            -1,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.048460998,
            -0.0000059999998,
            -0.034183
          ],
          "defaultRotationRaw": [
            1,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16329
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.39,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -102
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.44,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            -3,
            16383
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.38,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            -0.051221,
            -0.050380997,
            0.000113999995
          ],
          "defaultRotationRaw": [
            6421,
            -16377,
            26352
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            1,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.21,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.12478399,
            -0.0000029999999,
            -0.055861
          ],
          "defaultRotationRaw": [
            0,
            1,
            0
          ]
        },
        {
          "index": 26,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.024804,
            0.000015,
            -0.18413599
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            435,
            -4,
            -16384
          ]
        },
        {
          "index": 28,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.25,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.25,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.124773994,
            0.000004,
            0.055811
          ],
          "defaultRotationRaw": [
            0,
            1,
            0
          ]
        },
        {
          "index": 32,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.024753999,
            -0.000015,
            0.18419199
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            -0.000001,
            0
          ],
          "defaultRotationRaw": [
            -485,
            -3,
            -16384
          ]
        },
        {
          "index": 34,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.25,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 35,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.25,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 3,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293ec8",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.181201,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.25126198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.109730996,
            0,
            0.069166
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.049935997,
            0,
            0.040723
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16433
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.43153998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -100
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.43319398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            0,
            -0.086559996,
            -0.10825
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.109731995,
            0,
            -0.069166
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.049937,
            0,
            -0.040694
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16434
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.43153998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -100
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.43319398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            -0.086559996,
            -0.10825
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.39648297,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0.023999998,
            0.000001,
            0.000001
          ],
          "defaultRotationRaw": [
            8191,
            -16384,
            24575
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.209385,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.12563099,
            0,
            -0.06585
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.009001,
            0,
            -0.17187
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 28,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.260476,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.242725,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.12563199,
            0,
            0.06584799
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 32,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.009001999,
            0,
            0.171868
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16692
          ]
        },
        {
          "index": 34,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.260476,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 35,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.242725,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 4,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293ed4",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            0.90831095,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.176,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.059945,
            0,
            0.045785
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.035945,
            0,
            0.026214998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.311999,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.35199898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.059945,
            0,
            -0.045785997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.035945,
            0,
            -0.026214
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16322
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.311999,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -115
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.35199898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.304,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            -0.015999999,
            0,
            0.0001
          ],
          "defaultRotationRaw": [
            16384,
            -16378,
            16383
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16385
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.168,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.09471899,
            0,
            0.045787
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.014718999,
            0,
            0.138213
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0.000001,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 28,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.19999999,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.19999999,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.09471899,
            0,
            -0.045783997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 32,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.014718,
            0,
            -0.13821599
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 34,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.19999999,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 35,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.19999899,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 5,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293ee0",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.2891729,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.22,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.066843994,
            0,
            0.06745999
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.036843996,
            0,
            0.061102998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16333
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.44723198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -104
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.45604798,
            0,
            0
          ],
          "defaultRotationRaw": [
            -4,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            -0.013563,
            -0.128601,
            -0.103636
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.066843994,
            0,
            -0.06745999
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.036843996,
            0,
            -0.0611
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16333
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.44723198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -104
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.45604798,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0.013556,
            -0.12863699,
            -0.10359199
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.52633595,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            14
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0.07567199,
            0.0073439996,
            0.00014199999
          ],
          "defaultRotationRaw": [
            -24569,
            -16384,
            -8199
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            -7,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.21,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.163553,
            0.000225,
            0.101354994
          ],
          "defaultRotationRaw": [
            0,
            0,
            -14
          ]
        },
        {
          "index": 26,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.052529,
            -0.00013799999,
            0.186214
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16369
          ]
        },
        {
          "index": 27,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16332
          ]
        },
        {
          "index": 28,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.313157,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.29502797,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.163553,
            0.000225,
            -0.10135999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -14
          ]
        },
        {
          "index": 32,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.052529,
            -0.00013799999,
            -0.18620999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16369
          ]
        },
        {
          "index": 33,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16332
          ]
        },
        {
          "index": 34,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.313157,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 35,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.29502797,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 6,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293eec",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.18,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.25126198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.109730996,
            0,
            0.055834997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.049935997,
            0,
            0.035864998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16501
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.43153998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -100
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.43319398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            0,
            -0.100254,
            -0.113757
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.109731995,
            0,
            -0.055836998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.049937,
            0,
            -0.035834998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16501
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.43153998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -100
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.43319398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            -0.100254,
            -0.113757
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.39648297,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0.024000999,
            0.000001,
            0.000001
          ],
          "defaultRotationRaw": [
            8191,
            -16383,
            24575
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.209385,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.12563099,
            0,
            -0.055834
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.016943999,
            0,
            -0.169966
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16438
          ]
        },
        {
          "index": 28,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.260476,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            132
          ]
        },
        {
          "index": 29,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.242725,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.12563199,
            0,
            0.055837996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 32,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.016944999,
            0,
            0.16999999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16438
          ]
        },
        {
          "index": 34,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.260476,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            132
          ]
        },
        {
          "index": 35,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.242725,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 7,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293ef8",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.0243429,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.219219,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.02499,
            0,
            0.055834997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.00064,
            0,
            0.03416
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16284
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.37007198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -108
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.37015697,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            0,
            -0.057267997,
            -0.089338996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.024990998,
            0,
            -0.055836998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.000641,
            0,
            -0.034163
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16256
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.37007198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -108
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.37015697,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            -0.057267997,
            -0.089338996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.41831398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0.000001,
            0.000031,
            0.00014199999
          ],
          "defaultRotationRaw": [
            8191,
            -16383,
            24576
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.209385,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.13418,
            0,
            0.055837996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            -0.000807,
            -0.00013799999,
            0.149162
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16448
          ]
        },
        {
          "index": 28,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.257917,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.24328499,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.134179,
            0,
            -0.055834
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 32,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            -0.000807,
            -0.00013799999,
            -0.14916599
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16512
          ]
        },
        {
          "index": 34,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.257917,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            132
          ]
        },
        {
          "index": 35,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.24328499,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 8,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293f04",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            0.722532,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.16181299,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.047654998,
            0,
            0.035958
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.032158997,
            0,
            0.023078999
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16201
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.250439,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -130
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.26725698,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            0,
            -0.040397,
            -0.053021
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.047654998,
            0,
            -0.035958998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.03216,
            0,
            -0.023077998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16201
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.250437,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -129
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.26726198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            -0.040397,
            -0.053021
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.24526899,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0,
            0.000001,
            0.000001
          ],
          "defaultRotationRaw": [
            32767,
            -16384,
            0
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.13484399,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.080905996,
            0,
            -0.035956997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.010915999,
            0,
            -0.090163
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16375
          ]
        },
        {
          "index": 28,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.16293,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.15468399,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.080906995,
            0,
            0.035959996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 32,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.010918,
            0,
            0.090161994
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16455
          ]
        },
        {
          "index": 34,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.162932,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            165
          ]
        },
        {
          "index": 35,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.154682,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 9,
      "nodeCount": 35,
      "executableTableEntry": "0x0c293f10",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            16
          ],
          "defaultPosition": [
            0,
            1.199471,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            10
          ],
          "defaultPosition": [
            0.25126198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            10,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.109730996,
            0,
            0.055834997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            11,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.049935997,
            0,
            0.035864998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            12,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16506
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.43153998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -100
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            14,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.43319398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            0,
            15,
            0
          ],
          "parent": 8,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            11
          ],
          "defaultPosition": [
            -0.109731995,
            0,
            -0.055836998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 10,
          "children": [
            12
          ],
          "defaultPosition": [
            0.049937,
            0,
            -0.035834998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 12,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16602
          ]
        },
        {
          "index": 13,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0.43153998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -100
          ]
        },
        {
          "index": 14,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.43319398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "parent": 14,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 17,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 16,
          "children": [
            18
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 18,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 17,
          "children": [
            19,
            23,
            29
          ],
          "defaultPosition": [
            0.39648297,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 19,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0.023999998,
            0.000001,
            0.000001
          ],
          "defaultRotationRaw": [
            8191,
            -16384,
            24575
          ]
        },
        {
          "index": 20,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            22
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 21,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0.209385,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 22,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0.021256,
            -0.000002,
            0.094219
          ],
          "defaultRotationRaw": [
            16384,
            0,
            -16384
          ]
        },
        {
          "index": 23,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            29,
            3
          ],
          "parent": 18,
          "children": [
            24
          ],
          "defaultPosition": [
            -0.12563099,
            0,
            -0.055834
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            30,
            3
          ],
          "parent": 23,
          "children": [
            25
          ],
          "defaultPosition": [
            0.016943999,
            0,
            -0.169966
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 25,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            31,
            4
          ],
          "parent": 24,
          "children": [
            26
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16375
          ]
        },
        {
          "index": 26,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            32,
            4
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.260476,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 27,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0.242725,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 28,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            34,
            3
          ],
          "parent": 27,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 18,
          "children": [
            30
          ],
          "defaultPosition": [
            -0.12563199,
            0,
            0.055837996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 29,
          "children": [
            31
          ],
          "defaultPosition": [
            0.016944999,
            0,
            0.16999999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 31,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 30,
          "children": [
            32
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16375
          ]
        },
        {
          "index": 32,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.260476,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 33,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0.242725,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 34,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 33,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 10,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293f1c",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.18,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.25126198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.109730996,
            0,
            0.055834997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.049935997,
            0,
            0.035864998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16501
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.43153998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -100
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.43319398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            0,
            -0.100254,
            -0.113757
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.109731995,
            0,
            -0.055836998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.049937,
            0,
            -0.035834998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16501
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.43153998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -100
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.43319398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            -0.100254,
            -0.113757
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.39648297,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0.024000999,
            0.000001,
            0.000001
          ],
          "defaultRotationRaw": [
            8191,
            -16383,
            24575
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.209385,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.12563099,
            0,
            -0.055834
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.016943999,
            0,
            -0.169966
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16438
          ]
        },
        {
          "index": 28,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.260476,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            132
          ]
        },
        {
          "index": 29,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.242725,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.12563199,
            0,
            0.055837996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 32,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.016944999,
            0,
            0.16999999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16438
          ]
        },
        {
          "index": 34,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.260476,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            132
          ]
        },
        {
          "index": 35,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.242725,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 11,
      "nodeCount": 35,
      "executableTableEntry": "0x0c293f28",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            16
          ],
          "defaultPosition": [
            0,
            1.1453999,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            10
          ],
          "defaultPosition": [
            0.25126198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            10,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.109730996,
            0,
            0.055834997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            11,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.049935997,
            0,
            0.035837
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            12,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16329
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.39272898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -102
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            14,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.44460797,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            0,
            15,
            0
          ],
          "parent": 8,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            11
          ],
          "defaultPosition": [
            -0.109731995,
            0,
            -0.055836998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 10,
          "children": [
            12
          ],
          "defaultPosition": [
            0.049937,
            0,
            -0.035834998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 12,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16274
          ]
        },
        {
          "index": 13,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0.39272898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -102
          ]
        },
        {
          "index": 14,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.44462398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "parent": 14,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 17,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 16,
          "children": [
            18
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 18,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 17,
          "children": [
            19,
            23,
            29
          ],
          "defaultPosition": [
            0.38085198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 19,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0.000001,
            0.000001
          ],
          "defaultRotationRaw": [
            -32768,
            -16384,
            0
          ]
        },
        {
          "index": 20,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            22
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 21,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0.209385,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 22,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 23,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            29,
            3
          ],
          "parent": 18,
          "children": [
            24
          ],
          "defaultPosition": [
            -0.12563099,
            0,
            -0.055834
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            30,
            3
          ],
          "parent": 23,
          "children": [
            25
          ],
          "defaultPosition": [
            0.016950998,
            0,
            -0.16859
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 25,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            31,
            4
          ],
          "parent": 24,
          "children": [
            26
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16451
          ]
        },
        {
          "index": 26,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            32,
            4
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.24252999,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            133
          ]
        },
        {
          "index": 27,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0.25065798,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 28,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            34,
            3
          ],
          "parent": 27,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 18,
          "children": [
            30
          ],
          "defaultPosition": [
            -0.12563199,
            0,
            0.055837996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 29,
          "children": [
            31
          ],
          "defaultPosition": [
            0.016944999,
            0,
            0.16856599
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 31,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 30,
          "children": [
            32
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16451
          ]
        },
        {
          "index": 32,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.242525,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            133
          ]
        },
        {
          "index": 33,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0.25066498,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 34,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 33,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 12,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293f34",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.1078509,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.22,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.06999999,
            0,
            0.044999998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.03,
            0,
            0.040997997
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16284
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.39,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -103
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.44,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.06999999,
            0,
            -0.044999998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.030002,
            0,
            -0.041001
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16447
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.390001,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.43999898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.32999998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            14
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            -0.01,
            0,
            0
          ],
          "defaultRotationRaw": [
            32764,
            -16384,
            -3
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            14,
            16383
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.21,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.09251399,
            0.00012699999,
            -0.065
          ],
          "defaultRotationRaw": [
            0,
            0,
            -14
          ]
        },
        {
          "index": 26,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.036454998,
            -0.000103,
            -0.082003996
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16355
          ]
        },
        {
          "index": 27,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16479
          ]
        },
        {
          "index": 28,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.248,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            134
          ]
        },
        {
          "index": 29,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.24700299,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.09251399,
            0.00012699999,
            0.065
          ],
          "defaultRotationRaw": [
            0,
            0,
            -14
          ]
        },
        {
          "index": 32,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.03645,
            -0.000103,
            0.082003996
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16355
          ]
        },
        {
          "index": 33,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16479
          ]
        },
        {
          "index": 34,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.24579799,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            133
          ]
        },
        {
          "index": 35,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.24941199,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 13,
      "nodeCount": 37,
      "executableTableEntry": "0x0c293f40",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            18
          ],
          "defaultPosition": [
            0,
            1.1503999,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            11
          ],
          "defaultPosition": [
            0.25126198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            11,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.109730996,
            0,
            0.055834997
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            12,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.049935997,
            0,
            0.035837
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16383
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            14,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.39272898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            15,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.44460797,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            1,
            16,
            0
          ],
          "parent": 8,
          "children": [
            10
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 35,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            35,
            1,
            0,
            0,
            0,
            0,
            17,
            4
          ],
          "parent": 9,
          "children": [],
          "defaultPosition": [
            -0.000001,
            -0.08824,
            -0.115664996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.109731995,
            0,
            -0.055836998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 12,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0.049937,
            0,
            -0.035834998
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 13,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16329
          ]
        },
        {
          "index": 14,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.39272898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -102
          ]
        },
        {
          "index": 15,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 14,
          "children": [
            16
          ],
          "defaultPosition": [
            0.44462398,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            1,
            0,
            0
          ],
          "parent": 15,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 28,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            28,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 16,
          "children": [],
          "defaultPosition": [
            0,
            -0.08824,
            -0.115664996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 19,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 20,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            25,
            31
          ],
          "defaultPosition": [
            0.38085198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0,
            0.000001,
            0.000001
          ],
          "defaultRotationRaw": [
            -32768,
            -16384,
            0
          ]
        },
        {
          "index": 22,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23,
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 23,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0.209385,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 22,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            31,
            3
          ],
          "parent": 20,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.12563099,
            0,
            -0.055834
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            32,
            3
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.016950998,
            0,
            -0.16859
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 27,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 28,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            34,
            4
          ],
          "parent": 27,
          "children": [
            29
          ],
          "defaultPosition": [
            0.24252999,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            35,
            4
          ],
          "parent": 28,
          "children": [
            30
          ],
          "defaultPosition": [
            0.25065798,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            36,
            3
          ],
          "parent": 29,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 20,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.12563199,
            0,
            0.055837996
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 32,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.016944999,
            0,
            0.16856599
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16451
          ]
        },
        {
          "index": 34,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.242525,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            133
          ]
        },
        {
          "index": 35,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.25066498,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 14,
      "nodeCount": 35,
      "executableTableEntry": "0x0c293f4c",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            16
          ],
          "defaultPosition": [
            0,
            1.155605,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            10
          ],
          "defaultPosition": [
            0.22,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            10,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.06999999,
            0,
            0.044999998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            11,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.03,
            0,
            0.040997997
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            12,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16284
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.39,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -103
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            14,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.44,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            0,
            15,
            0
          ],
          "parent": 8,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            11
          ],
          "defaultPosition": [
            -0.06999999,
            0,
            -0.044999998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 10,
          "children": [
            12
          ],
          "defaultPosition": [
            0.030002,
            0,
            -0.041001
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 12,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16447
          ]
        },
        {
          "index": 13,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0.390001,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 14,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.43999898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "parent": 14,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 17,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 16,
          "children": [
            18
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 18,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 17,
          "children": [
            19,
            23,
            29
          ],
          "defaultPosition": [
            0.32999998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            14
          ]
        },
        {
          "index": 19,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            -0.01,
            0,
            0
          ],
          "defaultRotationRaw": [
            32764,
            -16384,
            -3
          ]
        },
        {
          "index": 20,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            22
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            14,
            16383
          ]
        },
        {
          "index": 21,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0.21,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 22,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 23,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            29,
            3
          ],
          "parent": 18,
          "children": [
            24
          ],
          "defaultPosition": [
            -0.09251399,
            0.00012699999,
            -0.065
          ],
          "defaultRotationRaw": [
            0,
            0,
            -14
          ]
        },
        {
          "index": 24,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            30,
            3
          ],
          "parent": 23,
          "children": [
            25
          ],
          "defaultPosition": [
            0.036454998,
            -0.000103,
            -0.082003996
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16355
          ]
        },
        {
          "index": 25,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            31,
            4
          ],
          "parent": 24,
          "children": [
            26
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16479
          ]
        },
        {
          "index": 26,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            32,
            4
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.248,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            134
          ]
        },
        {
          "index": 27,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0.24700299,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 28,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            34,
            3
          ],
          "parent": 27,
          "children": [],
          "defaultPosition": [
            0.000191,
            -0.0031869998,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -134
          ]
        },
        {
          "index": 29,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 18,
          "children": [
            30
          ],
          "defaultPosition": [
            -0.09251399,
            0.00012699999,
            0.065
          ],
          "defaultRotationRaw": [
            0,
            0,
            -14
          ]
        },
        {
          "index": 30,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 29,
          "children": [
            31
          ],
          "defaultPosition": [
            0.03645,
            -0.000103,
            0.082003996
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16355
          ]
        },
        {
          "index": 31,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 30,
          "children": [
            32
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16546
          ]
        },
        {
          "index": 32,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.24579799,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            132
          ]
        },
        {
          "index": 33,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0.24941199,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 34,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 33,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 15,
      "nodeCount": 35,
      "executableTableEntry": "0x0c293f58",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            16
          ],
          "defaultPosition": [
            0,
            1.0527239,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            10
          ],
          "defaultPosition": [
            0.21050699,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            10,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.06999999,
            0,
            0.044999998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            11,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.03,
            0,
            0.036427997
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            12,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16328
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.37099198,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -105
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            14,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.41818798,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            0,
            15,
            0
          ],
          "parent": 8,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            11
          ],
          "defaultPosition": [
            -0.06999999,
            0,
            -0.044999998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 10,
          "children": [
            12
          ],
          "defaultPosition": [
            0.030002,
            0,
            -0.036432996
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 12,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 13,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0.37099397,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 14,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.41818798,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "parent": 14,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 17,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 16,
          "children": [
            18
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 18,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 17,
          "children": [
            19,
            23,
            29
          ],
          "defaultPosition": [
            0.32999998,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            14
          ]
        },
        {
          "index": 19,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            -0.01807,
            -0.000001,
            0
          ],
          "defaultRotationRaw": [
            32764,
            -16384,
            -3
          ]
        },
        {
          "index": 20,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            22
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 21,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0.210137,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 22,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0.014830999,
            0,
            0.038459998
          ],
          "defaultRotationRaw": [
            0,
            8,
            0
          ]
        },
        {
          "index": 23,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            29,
            3
          ],
          "parent": 18,
          "children": [
            24
          ],
          "defaultPosition": [
            -0.09251399,
            0.00012699999,
            -0.065
          ],
          "defaultRotationRaw": [
            0,
            0,
            -14
          ]
        },
        {
          "index": 24,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            30,
            3
          ],
          "parent": 23,
          "children": [
            25
          ],
          "defaultPosition": [
            0.02257,
            -0.000103,
            -0.08
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 25,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            31,
            4
          ],
          "parent": 24,
          "children": [
            26
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 26,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            32,
            4
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.235414,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 27,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0.234624,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 28,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            34,
            3
          ],
          "parent": 27,
          "children": [],
          "defaultPosition": [
            0.000088999994,
            -0.000004,
            -0.00035
          ],
          "defaultRotationRaw": [
            0,
            0,
            67
          ]
        },
        {
          "index": 29,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 18,
          "children": [
            30
          ],
          "defaultPosition": [
            -0.09251399,
            0.00012699999,
            0.065
          ],
          "defaultRotationRaw": [
            0,
            0,
            -14
          ]
        },
        {
          "index": 30,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 29,
          "children": [
            31
          ],
          "defaultPosition": [
            0.022573998,
            -0.000103,
            0.08
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 31,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 30,
          "children": [
            32
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 32,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.235407,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 33,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0.23461899,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 34,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 33,
          "children": [],
          "defaultPosition": [
            0.00030599997,
            -0.000004,
            0.00035
          ],
          "defaultRotationRaw": [
            0,
            0,
            66
          ]
        }
      ]
    },
    {
      "index": 16,
      "nodeCount": 41,
      "executableTableEntry": "0x0c293f64",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            19
          ],
          "defaultPosition": [
            0,
            0.28838798,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -32655
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            10,
            16
          ],
          "defaultPosition": [
            0.16181299,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 22,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            1,
            0,
            0,
            1,
            1,
            10,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.0066959998,
            0.059265997,
            -0.065253
          ],
          "defaultRotationRaw": [
            0,
            0,
            -112
          ]
        },
        {
          "index": 5,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            11,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.0052599995,
            0.075569,
            0.0020309999
          ],
          "defaultRotationRaw": [
            0,
            0,
            32767
          ]
        },
        {
          "index": 6,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            12,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -23773
          ]
        },
        {
          "index": 7,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            25,
            3,
            0,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.08168,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            14387
          ]
        },
        {
          "index": 8,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            14,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.076931,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            0,
            15,
            0
          ],
          "parent": 8,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 29,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            1,
            0,
            0,
            1,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            11
          ],
          "defaultPosition": [
            -0.0066939997,
            0.059265,
            0.065248996
          ],
          "defaultRotationRaw": [
            0,
            0,
            -112
          ]
        },
        {
          "index": 11,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 10,
          "children": [
            12
          ],
          "defaultPosition": [
            0.0052589998,
            0.075569995,
            -0.0020309999
          ],
          "defaultRotationRaw": [
            -32767,
            32767,
            0
          ]
        },
        {
          "index": 12,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -23773
          ]
        },
        {
          "index": 13,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            32,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0.08168,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            14387
          ]
        },
        {
          "index": 14,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.076931,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "parent": 14,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 40,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            40,
            1,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            17
          ],
          "defaultPosition": [
            0.093352,
            -0.006989,
            -0.000008
          ],
          "defaultRotationRaw": [
            16327,
            -16383,
            16327
          ]
        },
        {
          "index": 17,
          "type": 41,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            41,
            1,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 16,
          "children": [
            18
          ],
          "defaultPosition": [
            0,
            0,
            0.068276994
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 43,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            43,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 17,
          "children": [],
          "defaultPosition": [
            0.000001,
            0,
            0.084533
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 19,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 20,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            210
          ]
        },
        {
          "index": 21,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 20,
          "children": [
            22,
            29,
            35
          ],
          "defaultPosition": [
            0.164453,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -210
          ]
        },
        {
          "index": 22,
          "type": 36,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            36,
            2,
            1,
            0,
            1,
            1,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23
          ],
          "defaultPosition": [
            0.000124,
            -0.009238999,
            -0.000001
          ],
          "defaultRotationRaw": [
            0,
            0,
            3
          ]
        },
        {
          "index": 23,
          "type": 37,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            37,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 22,
          "children": [
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            5118
          ]
        },
        {
          "index": 24,
          "type": 38,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            38,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 23,
          "children": [
            25
          ],
          "defaultPosition": [
            0.100536995,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            0,
            1,
            0,
            2
          ],
          "parent": 24,
          "children": [
            26
          ],
          "defaultPosition": [
            -0.015596,
            0.010260999,
            0.000001
          ],
          "defaultRotationRaw": [
            14962,
            -16383,
            30207
          ]
        },
        {
          "index": 26,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 25,
          "children": [
            27,
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            4485,
            16384
          ]
        },
        {
          "index": 27,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 26,
          "children": [],
          "defaultPosition": [
            0.128778,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 28,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 26,
          "children": [],
          "defaultPosition": [
            0.018925,
            0.000001,
            0.0036759998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            35,
            3
          ],
          "parent": 21,
          "children": [
            30
          ],
          "defaultPosition": [
            -0.014284999,
            -0.032438997,
            -0.03969
          ],
          "defaultRotationRaw": [
            0,
            0,
            13768
          ]
        },
        {
          "index": 30,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            36,
            3
          ],
          "parent": 29,
          "children": [
            31
          ],
          "defaultPosition": [
            -0.032867998,
            -0.014017999,
            -0.026030999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -13768
          ]
        },
        {
          "index": 31,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            37,
            4
          ],
          "parent": 30,
          "children": [
            32
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -21466
          ]
        },
        {
          "index": 32,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            38,
            4
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.11812,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            10118
          ]
        },
        {
          "index": 33,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            39,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0.116421,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 34,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            40,
            3
          ],
          "parent": 33,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 35,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 21,
          "children": [
            36
          ],
          "defaultPosition": [
            -0.014285999,
            -0.032438997,
            0.03969
          ],
          "defaultRotationRaw": [
            0,
            0,
            13768
          ]
        },
        {
          "index": 36,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 35,
          "children": [
            37
          ],
          "defaultPosition": [
            -0.032869,
            -0.01402,
            0.026023999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -13768
          ]
        },
        {
          "index": 37,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 36,
          "children": [
            38
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -21466
          ]
        },
        {
          "index": 38,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 37,
          "children": [
            39
          ],
          "defaultPosition": [
            0.11812,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            10118
          ]
        },
        {
          "index": 39,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 38,
          "children": [
            40
          ],
          "defaultPosition": [
            0.116421,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 40,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 39,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 17,
      "nodeCount": 42,
      "executableTableEntry": "0x0c293f70",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            17
          ],
          "defaultPosition": [
            0,
            0.44407398,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            -0.000008,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            20,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            32705
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            10,
            16
          ],
          "defaultPosition": [
            0.18669899,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            10,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.0070129996,
            0.062594,
            0.064843
          ],
          "defaultRotationRaw": [
            0,
            0,
            20096
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            11,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            -0.030542,
            -0.042891,
            0.014194
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            12,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -23515
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            32,
            3,
            0,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.214488,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            6249
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            14,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.16205099,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            0,
            15,
            0
          ],
          "parent": 8,
          "children": [],
          "defaultPosition": [
            -0.000001,
            0.000022999999,
            0.000028999999
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            1,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            11
          ],
          "defaultPosition": [
            -0.0070129996,
            0.062590994,
            -0.064836994
          ],
          "defaultRotationRaw": [
            0,
            0,
            20096
          ]
        },
        {
          "index": 11,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 10,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.030539999,
            -0.042889997,
            -0.014195
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 12,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -23515
          ]
        },
        {
          "index": 13,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            25,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0.21448699,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            6249
          ]
        },
        {
          "index": 14,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.16205299,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "parent": 14,
          "children": [],
          "defaultPosition": [
            -0.000001,
            0.000022999999,
            0.00003
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 43,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            43,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 3,
          "children": [],
          "defaultPosition": [
            0.13216199,
            0.024959998,
            -0.000005
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 17,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            18
          ],
          "defaultPosition": [
            0,
            -0.000008,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 18,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 17,
          "children": [
            19
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            1161
          ]
        },
        {
          "index": 19,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 18,
          "children": [
            20,
            30,
            36
          ],
          "defaultPosition": [
            0.21988499,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 20,
          "type": 36,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            36,
            2,
            1,
            0,
            1,
            1,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21
          ],
          "defaultPosition": [
            0.000001,
            0.000004,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            1571
          ]
        },
        {
          "index": 21,
          "type": 37,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            37,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 20,
          "children": [
            22
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            3554
          ]
        },
        {
          "index": 22,
          "type": 38,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            38,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23
          ],
          "defaultPosition": [
            0.187014,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 23,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            0,
            1,
            0,
            2
          ],
          "parent": 22,
          "children": [
            24
          ],
          "defaultPosition": [
            0.000033999997,
            0.000016999998,
            0
          ],
          "defaultRotationRaw": [
            12989,
            -16383,
            28539
          ]
        },
        {
          "index": 24,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 23,
          "children": [
            25,
            26
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            5843,
            16384
          ]
        },
        {
          "index": 25,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 24,
          "children": [],
          "defaultPosition": [
            0.13485,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 26,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 24,
          "children": [
            27,
            28,
            29
          ],
          "defaultPosition": [
            -0.000002,
            0.000001,
            0.000002
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 27,
          "type": 44,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            44,
            1,
            0,
            0,
            1,
            0,
            28,
            4
          ],
          "parent": 26,
          "children": [],
          "defaultPosition": [
            -0.025410999,
            0.040000997,
            0.030896999
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 28,
          "type": 45,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            45,
            1,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 26,
          "children": [],
          "defaultPosition": [
            -0.025410999,
            -0.039998997,
            0.030896999
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 46,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            46,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 26,
          "children": [],
          "defaultPosition": [
            0.102354996,
            0,
            0.040659
          ],
          "defaultRotationRaw": [
            0,
            -169,
            0
          ]
        },
        {
          "index": 30,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            36,
            3
          ],
          "parent": 19,
          "children": [
            31
          ],
          "defaultPosition": [
            -0.04669,
            -0.086761996,
            -0.035958998
          ],
          "defaultRotationRaw": [
            0,
            0,
            15034
          ]
        },
        {
          "index": 31,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            37,
            3
          ],
          "parent": 30,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.055710997,
            -0.0049869996,
            -0.0151619995
          ],
          "defaultRotationRaw": [
            0,
            0,
            -15403
          ]
        },
        {
          "index": 32,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            38,
            4
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16455
          ]
        },
        {
          "index": 33,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            10,
            3,
            1,
            0,
            0,
            1,
            39,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0.172375,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -1366
          ]
        },
        {
          "index": 34,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            40,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.102749996,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 35,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            41,
            3
          ],
          "parent": 34,
          "children": [],
          "defaultPosition": [
            -0.000004,
            -0.000001,
            -0.0000029999999
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 19,
          "children": [
            37
          ],
          "defaultPosition": [
            -0.046690997,
            -0.086762995,
            0.035958998
          ],
          "defaultRotationRaw": [
            0,
            0,
            15034
          ]
        },
        {
          "index": 37,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 36,
          "children": [
            38
          ],
          "defaultPosition": [
            -0.055708997,
            -0.004986,
            0.0151619995
          ],
          "defaultRotationRaw": [
            0,
            0,
            -15403
          ]
        },
        {
          "index": 38,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 37,
          "children": [
            39
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16453
          ]
        },
        {
          "index": 39,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            16,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 38,
          "children": [
            40
          ],
          "defaultPosition": [
            0.172373,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -1370
          ]
        },
        {
          "index": 40,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 39,
          "children": [
            41
          ],
          "defaultPosition": [
            0.102754,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 41,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 40,
          "children": [],
          "defaultPosition": [
            -0.000004,
            0,
            -0.0000029999999
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 18,
      "nodeCount": 43,
      "executableTableEntry": "0x0c293f7c",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            19
          ],
          "defaultPosition": [
            0,
            0.39999998,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -32655
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            10,
            16
          ],
          "defaultPosition": [
            0.16181299,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            1,
            0,
            0,
            1,
            1,
            10,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.018097999,
            0.024899999,
            0.058999
          ],
          "defaultRotationRaw": [
            0,
            0,
            13588
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            11,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.15458,
            -0.000339,
            0.000039
          ],
          "defaultRotationRaw": [
            0,
            0,
            22717
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            12,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -24950
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            32,
            3,
            0,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.113611,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            7815
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            14,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.095433995,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            0,
            15,
            0
          ],
          "parent": 8,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 22,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            1,
            0,
            0,
            1,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            11
          ],
          "defaultPosition": [
            -0.018097999,
            0.024899999,
            -0.059001
          ],
          "defaultRotationRaw": [
            0,
            0,
            13588
          ]
        },
        {
          "index": 11,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 10,
          "children": [
            12
          ],
          "defaultPosition": [
            0.15458,
            -0.00033699998,
            -0.000035999998
          ],
          "defaultRotationRaw": [
            0,
            0,
            22717
          ]
        },
        {
          "index": 12,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -24950
          ]
        },
        {
          "index": 13,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            25,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0.113611,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            7815
          ]
        },
        {
          "index": 14,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.095433995,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "parent": 14,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 40,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            40,
            1,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            17
          ],
          "defaultPosition": [
            0.066502,
            -0.017600998,
            -0.000001
          ],
          "defaultRotationRaw": [
            -32768,
            -32768,
            32632
          ]
        },
        {
          "index": 17,
          "type": 41,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            41,
            1,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 16,
          "children": [
            18
          ],
          "defaultPosition": [
            0.021,
            -0.031999998,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 43,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            43,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 17,
          "children": [],
          "defaultPosition": [
            -0.0616,
            -0.049,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 19,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 20,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -304
          ]
        },
        {
          "index": 21,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 20,
          "children": [
            22,
            31,
            37
          ],
          "defaultPosition": [
            0.164453,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 22,
          "type": 36,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            36,
            2,
            1,
            0,
            1,
            1,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            304
          ]
        },
        {
          "index": 23,
          "type": 37,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            37,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 22,
          "children": [
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            8456
          ]
        },
        {
          "index": 24,
          "type": 38,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            38,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 23,
          "children": [
            25
          ],
          "defaultPosition": [
            0.15478899,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            0,
            1,
            0,
            2
          ],
          "parent": 24,
          "children": [
            26
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            12989,
            -16383,
            28539
          ]
        },
        {
          "index": 26,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 25,
          "children": [
            27,
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            4485,
            16384
          ]
        },
        {
          "index": 27,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 26,
          "children": [],
          "defaultPosition": [
            0.13484399,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 28,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 26,
          "children": [
            29,
            30
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 45,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            45,
            1,
            0,
            0,
            1,
            0,
            30,
            4
          ],
          "parent": 28,
          "children": [],
          "defaultPosition": [
            0.041428998,
            -0.026898999,
            0.11011
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 30,
          "type": 44,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            44,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 28,
          "children": [],
          "defaultPosition": [
            0.041428998,
            0.026901,
            0.11011
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 31,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            37,
            3
          ],
          "parent": 21,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.006927,
            -0.054585,
            -0.064312994
          ],
          "defaultRotationRaw": [
            0,
            0,
            13768
          ]
        },
        {
          "index": 32,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            38,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.014427,
            -0.002293,
            0.0027919998
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            39,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -12754
          ]
        },
        {
          "index": 34,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            40,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.181763,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            1448
          ]
        },
        {
          "index": 35,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            41,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.13995299,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            42,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 37,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 21,
          "children": [
            38
          ],
          "defaultPosition": [
            -0.0069279997,
            -0.054583997,
            0.064315
          ],
          "defaultRotationRaw": [
            0,
            0,
            13768
          ]
        },
        {
          "index": 38,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 37,
          "children": [
            39
          ],
          "defaultPosition": [
            0.014428999,
            -0.002293,
            -0.0027939999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 39,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 38,
          "children": [
            40
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -12754
          ]
        },
        {
          "index": 40,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 39,
          "children": [
            41
          ],
          "defaultPosition": [
            0.181762,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            1448
          ]
        },
        {
          "index": 41,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 40,
          "children": [
            42
          ],
          "defaultPosition": [
            0.13995399,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 42,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 41,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 19,
      "nodeCount": 35,
      "executableTableEntry": "0x0c293f88",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            16
          ],
          "defaultPosition": [
            0,
            1.048932,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            10
          ],
          "defaultPosition": [
            0.21050699,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 29,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            0,
            0,
            0,
            1,
            1,
            10,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.063235,
            0,
            0.044999998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            11,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            0.036765996,
            0,
            0.056427997
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 6,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            12,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 7,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            32,
            3,
            1,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.39138898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 8,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            14,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.380132,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            0,
            15,
            0
          ],
          "parent": 8,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 22,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            0,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            11
          ],
          "defaultPosition": [
            -0.063235,
            0,
            -0.044999998
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 10,
          "children": [
            12
          ],
          "defaultPosition": [
            0.036765996,
            0,
            -0.056427997
          ],
          "defaultRotationRaw": [
            0,
            0,
            16383
          ]
        },
        {
          "index": 12,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16331
          ]
        },
        {
          "index": 13,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            25,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0.39138898,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -106
          ]
        },
        {
          "index": 14,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.380132,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "parent": 14,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            17
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 17,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 16,
          "children": [
            18
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 18,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 17,
          "children": [
            19,
            23,
            29
          ],
          "defaultPosition": [
            0.35049498,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 19,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            1,
            1,
            0,
            2
          ],
          "parent": 18,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            -0.000001,
            0
          ],
          "defaultRotationRaw": [
            -32768,
            -16383,
            0
          ]
        },
        {
          "index": 20,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21,
            22
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            16384
          ]
        },
        {
          "index": 21,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0.21008499,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 22,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 20,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 23,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            1,
            1,
            29,
            3
          ],
          "parent": 18,
          "children": [
            24
          ],
          "defaultPosition": [
            -0.082513995,
            -0.000001,
            0.065
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 24,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            30,
            3
          ],
          "parent": 23,
          "children": [
            25
          ],
          "defaultPosition": [
            0.02257,
            -0.000103,
            0.11
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 25,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            31,
            4
          ],
          "parent": 24,
          "children": [
            26
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16443
          ]
        },
        {
          "index": 26,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            32,
            4
          ],
          "parent": 25,
          "children": [
            27
          ],
          "defaultPosition": [
            0.274265,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            135
          ]
        },
        {
          "index": 27,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            33,
            4
          ],
          "parent": 26,
          "children": [
            28
          ],
          "defaultPosition": [
            0.210981,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 28,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            34,
            3
          ],
          "parent": 27,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 18,
          "children": [
            30
          ],
          "defaultPosition": [
            -0.082513995,
            -0.000001,
            -0.065
          ],
          "defaultRotationRaw": [
            0,
            0,
            14
          ]
        },
        {
          "index": 30,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 29,
          "children": [
            31
          ],
          "defaultPosition": [
            0.02257,
            -0.00013399999,
            -0.11
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 31,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 30,
          "children": [
            32
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16325
          ]
        },
        {
          "index": 32,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            0.274265,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            136
          ]
        },
        {
          "index": 33,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0.210981,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 34,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 33,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    },
    {
      "index": 20,
      "nodeCount": 43,
      "executableTableEntry": "0x0c293f94",
      "nodes": [
        {
          "index": 0,
          "type": 0,
          "solverClass": 6,
          "solverSubtype": 0,
          "descriptorHeader": [
            0,
            6,
            0,
            0,
            0,
            2,
            0,
            0
          ],
          "parent": null,
          "children": [
            1,
            19
          ],
          "defaultPosition": [
            0,
            0.11971,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 1,
          "type": 19,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            19,
            2,
            1,
            0,
            1,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            2
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 2,
          "type": 20,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            20,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 1,
          "children": [
            3
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -32767
          ]
        },
        {
          "index": 3,
          "type": 21,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            21,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 2,
          "children": [
            4,
            10,
            16
          ],
          "defaultPosition": [
            0.078888,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 4,
          "type": 22,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            22,
            1,
            0,
            0,
            1,
            1,
            10,
            4
          ],
          "parent": 3,
          "children": [
            5
          ],
          "defaultPosition": [
            -0.017099999,
            0.01872,
            -0.026099999
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 5,
          "type": 23,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            23,
            2,
            2,
            0,
            0,
            1,
            11,
            3
          ],
          "parent": 4,
          "children": [
            6
          ],
          "defaultPosition": [
            -0.0047589997,
            0.039024998,
            -0.000062
          ],
          "defaultRotationRaw": [
            0,
            0,
            -29230
          ]
        },
        {
          "index": 6,
          "type": 24,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            24,
            3,
            1,
            0,
            0,
            1,
            12,
            4
          ],
          "parent": 5,
          "children": [
            7
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -27086
          ]
        },
        {
          "index": 7,
          "type": 25,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            25,
            3,
            0,
            0,
            0,
            1,
            13,
            4
          ],
          "parent": 6,
          "children": [
            8
          ],
          "defaultPosition": [
            0.035788,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            12366
          ]
        },
        {
          "index": 8,
          "type": 26,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            26,
            4,
            0,
            1,
            0,
            1,
            14,
            4
          ],
          "parent": 7,
          "children": [
            9
          ],
          "defaultPosition": [
            0.030062,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 9,
          "type": 27,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            27,
            1,
            0,
            0,
            0,
            0,
            15,
            0
          ],
          "parent": 8,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 10,
          "type": 29,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            29,
            1,
            0,
            0,
            1,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            11
          ],
          "defaultPosition": [
            -0.017099999,
            0.01872,
            0.026099999
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 11,
          "type": 30,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            30,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 10,
          "children": [
            12
          ],
          "defaultPosition": [
            -0.0047589997,
            0.039024,
            0.000063
          ],
          "defaultRotationRaw": [
            0,
            0,
            -29230
          ]
        },
        {
          "index": 12,
          "type": 31,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            31,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 11,
          "children": [
            13
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -27086
          ]
        },
        {
          "index": 13,
          "type": 32,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            32,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 12,
          "children": [
            14
          ],
          "defaultPosition": [
            0.035788,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            12366
          ]
        },
        {
          "index": 14,
          "type": 33,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            33,
            4,
            0,
            1,
            0,
            1,
            0,
            4
          ],
          "parent": 13,
          "children": [
            15
          ],
          "defaultPosition": [
            0.030062,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 15,
          "type": 34,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            34,
            1,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "parent": 14,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 16,
          "type": 40,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            40,
            1,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 3,
          "children": [
            17
          ],
          "defaultPosition": [
            0.023201998,
            0.0026609998,
            -0.000001
          ],
          "defaultRotationRaw": [
            16383,
            -16383,
            16384
          ]
        },
        {
          "index": 17,
          "type": 41,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            41,
            1,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 16,
          "children": [
            18
          ],
          "defaultPosition": [
            0,
            0,
            0.027311
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 18,
          "type": 43,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            43,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 17,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0.033813
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 19,
          "type": 1,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            1,
            2,
            1,
            0,
            0,
            1,
            0,
            1
          ],
          "parent": 0,
          "children": [
            20
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            16384,
            0
          ]
        },
        {
          "index": 20,
          "type": 2,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            2,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 19,
          "children": [
            21
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 21,
          "type": 3,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            3,
            4,
            0,
            0,
            0,
            3,
            0,
            4
          ],
          "parent": 20,
          "children": [
            22,
            31,
            37
          ],
          "defaultPosition": [
            0.083221994,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 22,
          "type": 36,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            36,
            2,
            1,
            0,
            1,
            1,
            0,
            4
          ],
          "parent": 21,
          "children": [
            23
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            304
          ]
        },
        {
          "index": 23,
          "type": 37,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            37,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 22,
          "children": [
            24
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            8456
          ]
        },
        {
          "index": 24,
          "type": 38,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            38,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 23,
          "children": [
            25
          ],
          "defaultPosition": [
            0.018782,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 25,
          "type": 4,
          "solverClass": 2,
          "solverSubtype": 1,
          "descriptorHeader": [
            4,
            2,
            1,
            0,
            0,
            1,
            0,
            2
          ],
          "parent": 24,
          "children": [
            26
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            12989,
            -16383,
            28539
          ]
        },
        {
          "index": 26,
          "type": 5,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            5,
            3,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 25,
          "children": [
            27,
            28
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            4485,
            16384
          ]
        },
        {
          "index": 27,
          "type": 6,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            6,
            4,
            0,
            0,
            1,
            0,
            0,
            4
          ],
          "parent": 26,
          "children": [],
          "defaultPosition": [
            0.052562997,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 28,
          "type": 47,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            47,
            1,
            0,
            0,
            0,
            2,
            0,
            4
          ],
          "parent": 26,
          "children": [
            29,
            30
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 29,
          "type": 44,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            44,
            1,
            0,
            0,
            1,
            0,
            30,
            4
          ],
          "parent": 28,
          "children": [],
          "defaultPosition": [
            0.009676999,
            0.0297,
            0.035005998
          ],
          "defaultRotationRaw": [
            20205,
            -5156,
            -18262
          ]
        },
        {
          "index": 30,
          "type": 45,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            45,
            1,
            0,
            0,
            0,
            0,
            0,
            4
          ],
          "parent": 28,
          "children": [],
          "defaultPosition": [
            0.009676999,
            -0.0297,
            0.035005998
          ],
          "defaultRotationRaw": [
            20205,
            5156,
            -14505
          ]
        },
        {
          "index": 31,
          "type": 7,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            7,
            0,
            0,
            0,
            1,
            1,
            37,
            3
          ],
          "parent": 21,
          "children": [
            32
          ],
          "defaultPosition": [
            -0.021943,
            -0.013565999,
            -0.016199999
          ],
          "defaultRotationRaw": [
            0,
            0,
            13768
          ]
        },
        {
          "index": 32,
          "type": 8,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            8,
            2,
            2,
            0,
            0,
            1,
            38,
            3
          ],
          "parent": 31,
          "children": [
            33
          ],
          "defaultPosition": [
            -0.022736998,
            0.00068,
            -0.010857999
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 33,
          "type": 9,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            9,
            3,
            1,
            0,
            0,
            1,
            39,
            4
          ],
          "parent": 32,
          "children": [
            34
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -18102
          ]
        },
        {
          "index": 34,
          "type": 10,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            10,
            3,
            0,
            0,
            0,
            1,
            40,
            4
          ],
          "parent": 33,
          "children": [
            35
          ],
          "defaultPosition": [
            0.038195997,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            8964
          ]
        },
        {
          "index": 35,
          "type": 11,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            11,
            4,
            0,
            0,
            0,
            1,
            41,
            4
          ],
          "parent": 34,
          "children": [
            36
          ],
          "defaultPosition": [
            0.051508,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 36,
          "type": 12,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            12,
            1,
            0,
            0,
            0,
            0,
            42,
            3
          ],
          "parent": 35,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 37,
          "type": 13,
          "solverClass": 0,
          "solverSubtype": 0,
          "descriptorHeader": [
            13,
            0,
            0,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 21,
          "children": [
            38
          ],
          "defaultPosition": [
            -0.021943,
            -0.013565999,
            0.016199999
          ],
          "defaultRotationRaw": [
            0,
            0,
            13768
          ]
        },
        {
          "index": 38,
          "type": 14,
          "solverClass": 2,
          "solverSubtype": 2,
          "descriptorHeader": [
            14,
            2,
            2,
            0,
            0,
            1,
            0,
            3
          ],
          "parent": 37,
          "children": [
            39
          ],
          "defaultPosition": [
            -0.022737999,
            0.000679,
            0.010859
          ],
          "defaultRotationRaw": [
            0,
            0,
            -16384
          ]
        },
        {
          "index": 39,
          "type": 15,
          "solverClass": 3,
          "solverSubtype": 1,
          "descriptorHeader": [
            15,
            3,
            1,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 38,
          "children": [
            40
          ],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            -18102
          ]
        },
        {
          "index": 40,
          "type": 16,
          "solverClass": 3,
          "solverSubtype": 0,
          "descriptorHeader": [
            16,
            3,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 39,
          "children": [
            41
          ],
          "defaultPosition": [
            0.038195997,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            8964
          ]
        },
        {
          "index": 41,
          "type": 17,
          "solverClass": 4,
          "solverSubtype": 0,
          "descriptorHeader": [
            17,
            4,
            0,
            0,
            0,
            1,
            0,
            4
          ],
          "parent": 40,
          "children": [
            42
          ],
          "defaultPosition": [
            0.051508,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        },
        {
          "index": 42,
          "type": 18,
          "solverClass": 1,
          "solverSubtype": 0,
          "descriptorHeader": [
            18,
            1,
            0,
            0,
            0,
            0,
            0,
            3
          ],
          "parent": 41,
          "children": [],
          "defaultPosition": [
            0,
            0,
            0
          ],
          "defaultRotationRaw": [
            0,
            0,
            0
          ]
        }
      ]
    }
  ]
};
